const PL = 'pl'
const NL = 'nl'
const EN = 'en'
const UA = 'ua'
const FR = 'fr'
const GR = 'gr'
const RU = 'ru'
const ES = 'es'
const ID = 'id'

export default {
  getSupportedLangs: () => [PL, EN, NL, UA, FR, GR, RU, ES, ID],
}
